<template>
  <div>
    <!-- modal -->
    <b-modal
      id="modal-attach-list"
      ref="my-modal-list"
      title="รายการเอกสารแนบ"
      ok-title="ปิด"
      ok-variant="outline-secondary"
      size="lg"
      ok-only
      centered
    >
      <b-list-group class="mb-2 mt-2">
        <b-list-group-item
          v-for="item in items"
          :key="item.attachId"
          class="d-flex "
        >
          <b-link
            :href="item.filePath"
            target="_blank"
          >
            <span class="mr-1">
              <feather-icon
                icon="FileIcon"
                size="16"
              />
            </span>
            <span>{{ item.fileName }}</span>
          </b-link>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BModal, VBModal, BListGroup, BListGroupItem, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BLink,
    BButton,
    BFormGroup,
    BListGroup,
    BListGroupItem,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
    props: {
    items: 
    {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
    }
  },
}
</script>
